__turbopack_context__.v({
  "sidebarBrandLink": "SidebarHeader-module__O5KUfW__sidebarBrandLink",
  "sidebarCollapsedButton": "SidebarHeader-module__O5KUfW__sidebarCollapsedButton",
  "sidebarCollapsedIconGrowBack": "SidebarHeader-module__O5KUfW__sidebarCollapsedIconGrowBack",
  "sidebarCollapsedLayer": "SidebarHeader-module__O5KUfW__sidebarCollapsedLayer",
  "sidebarCollapsedLayerCue": "SidebarHeader-module__O5KUfW__sidebarCollapsedLayerCue",
  "sidebarCollapsedLayerHidden": "SidebarHeader-module__O5KUfW__sidebarCollapsedLayerHidden",
  "sidebarCollapsedLayerVisible": "SidebarHeader-module__O5KUfW__sidebarCollapsedLayerVisible",
  "sidebarCollapsedOpenIcon": "SidebarHeader-module__O5KUfW__sidebarCollapsedOpenIcon",
  "sidebarCollapsedOpenIconCue": "SidebarHeader-module__O5KUfW__sidebarCollapsedOpenIconCue",
  "sidebarCollapsedVisual": "SidebarHeader-module__O5KUfW__sidebarCollapsedVisual",
  "sidebarCompactLogo": "SidebarHeader-module__O5KUfW__sidebarCompactLogo",
  "sidebarExtendedLogo": "SidebarHeader-module__O5KUfW__sidebarExtendedLogo",
  "sidebarHeaderCollapsed": "SidebarHeader-module__O5KUfW__sidebarHeaderCollapsed",
  "sidebarHeaderExpanded": "SidebarHeader-module__O5KUfW__sidebarHeaderExpanded",
  "sidebarHeaderRoot": "SidebarHeader-module__O5KUfW__sidebarHeaderRoot",
  "sidebarHeaderToggle": "SidebarHeader-module__O5KUfW__sidebarHeaderToggle",
  "sidebarHeaderToggleExpanded": "SidebarHeader-module__O5KUfW__sidebarHeaderToggleExpanded",
  "sidebarHeaderToggleIcon": "SidebarHeader-module__O5KUfW__sidebarHeaderToggleIcon",
});
